import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

export default function ProjectSettingsRedirect({ section = "general" }) {
  const { projectId } = useParams();
  const location = useLocation();
  const search = location.search || "";

  return (
    <Navigate
      replace
      to={`/dashboard/proyectos/${projectId}/configuracion/${section}${search}`}
    />
  );
}
